import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { BriefcaseBusiness, Inbox, ScrollText, ShieldCheck } from "lucide-react";
import { OperatorGrants } from "@/components/operators/OperatorGrants";
import { AccessRequests } from "@/components/operators/AccessRequests";
import { ActivityLog } from "@/components/operators/ActivityLog";

const TABS = [
  { k: "operators", label: "Operadoras", icon: BriefcaseBusiness },
  { k: "requests", label: "Solicitações", icon: Inbox },
  { k: "logs", label: "Log de Atividades", icon: ScrollText },
];

export default function OperatorsAdmin() {
  const [tab, setTab] = useState("operators");
  const [pending, setPending] = useState(0);
  const [operators, setOperators] = useState([]);
  const [competitions, setCompetitions] = useState([]);

  const load = async () => {
    const [p, o, c] = await Promise.all([
      api.get("/admin/access-requests/count"),
      api.get("/admin/operators"),
      api.get("/competitions"),
    ]);
    setPending(p.data.pending || 0);
    setOperators(o.data);
    setCompetitions(c.data);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div data-testid="operators-admin-page">
      <div className="mb-6">
        <div className="overline mb-2 flex items-center gap-1">
          <ShieldCheck size={12} /> Controle de acesso
        </div>
        <h1 className="font-display text-5xl font-black tracking-tight">OPERADORAS DE EVENTO</h1>
        <div className="text-sm text-[var(--text-secondary)] mt-1">
          Libere campeonatos, aprove solicitações e acompanhe tudo que cada operadora faz — com data e hora.
        </div>
      </div>

      <div className="card p-4 mb-6 text-xs text-[var(--text-secondary)] grid grid-cols-1 md:grid-cols-2 gap-2">
        <div>
          <span className="text-[#5AF78E] font-bold uppercase tracking-widest mr-2">Pode</span>
          gerenciar inscrições, confirmar/estornar pagamentos, rejeitar inscrições, imprimir súmulas e roteiro, ver atletas por categoria.
        </div>
        <div>
          <span className="text-[#C9A84C] font-bold uppercase tracking-widest mr-2">Não pode</span>
          acessar campeonatos não liberados, criar/excluir campeonatos, mexer em árbitros, ver configurações, criar usuários ou excluir inscrições.
        </div>
      </div>

      <div className="flex gap-2 mb-6 flex-wrap">
        {TABS.map((t) => (
          <button
            key={t.k}
            data-testid={`op-tab-${t.k}`}
            className={"btn-ghost inline-flex items-center gap-2 " + (tab === t.k ? "!bg-[#C9A84C] !text-[#0A0A0A] !border-[#C9A84C]" : "")}
            onClick={() => setTab(t.k)}
          >
            <t.icon size={14} /> {t.label}
            {t.k === "requests" && pending > 0 && (
              <span data-testid="op-tab-requests-badge" className="ml-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#C9A84C] text-black text-[10px] font-black flex items-center justify-center">
                {pending}
              </span>
            )}
          </button>
        ))}
      </div>

      {tab === "operators" && <OperatorGrants operators={operators} competitions={competitions} onChanged={load} />}
      {tab === "requests" && <AccessRequests onChanged={load} />}
      {tab === "logs" && <ActivityLog operators={operators} competitions={competitions} />}
    </div>
  );
}
